import { Account, Client, Functions, TablesDB } from 'appwrite';
import { appwriteConfig } from '../../config/environment';

export const appwriteClient = new Client()
  .setEndpoint(appwriteConfig.endpoint)
  .setProject(appwriteConfig.projectId);

export const account = new Account(appwriteClient);
export const functions = new Functions(appwriteClient);
export const tablesDB = new TablesDB(appwriteClient);
